
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anti-pirate",
      function () {
        return require("private-next-pages/anti-pirate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anti-pirate"])
      });
    }
  